// extracted by mini-css-extract-plugin
module.exports = {"container":"success_container__1X6YI","title":"success_title__2Esx9","btn":"success_btn__zorKJ"};